import { UiElementProperty } from './ui-element-property';
export class State {
  name: string;
  guid: string;
  description: string[];
  src: string;
  properties: UiElementProperty[] = [];
  manualImagePath = '';
}
